<template>
  <kst-page-export
    :catalog="SlsSearchCatalog"
    :params="Model.Search.ListParams"
    :search="searchData"
    @init="handleInit"
    @export="handleExport"
  >
    <Export
      :userData="userData"
      :searchData="searchData"
      @init="handleExport_init"
    />

    <kst-check disabled
      v-model="userData.WithList"
      :label="Info.Export.List.Excel.Option.List"
    />
    <kst-check 
      v-model="userData.WithItems"
      :label="Info.Export.List.Excel.Option.SalesItem"
    />
    <kst-check 
      v-model="userData.WithItemsByClient"
      :label="Info.Export.List.Excel.Option.SalesItemListByClient"
    />
  </kst-page-export>
</template>

<script>
import Info from "../SlsInfo.js";
import Model from "../SlsModel.js";
import SlsSearchCatalog from "../SlsSearchCatalog.js";
import Services from "../../../services/Api/SalesServices.js";

import Export from "./SlsExL_Export.vue";

export default {
  components: {
    Export
  },
  data: () => ({
    Info: Info,
    SlsSearchCatalog: SlsSearchCatalog,
    Model: Model,
    searchData: {
      Search: "",
      ClientName: "",
      ClientID: null, 
      Date: null,
      StatusID: null,
      WarehouseID: null
    },
    userData: {
      WithList: true,
      WithItems: true,
      WithItemsByClient: false
    },
    // func
    exportExcelFunc: null
  }),
  methods: {
    /*** by page ***/

    handleInit() {
      this.resetData();
    },

    handleExport(loadExport) {
      const options = this.getListOptions();
      const config = Services.getExportList(options);
      loadExport(config, this.handleExport_success);
    },
    handleExport_success(data, fileName) {
      this.exportExcelFunc(data, fileName);
    },

    /*** export ***/

    handleExport_init(exportExcel) {
      this.exportExcelFunc = exportExcel;
    },

    /*** custom ***/

    resetData() {
      this.userData.WithList = true;
      this.userData.WithItems = true;
      this.userData.WithItemsByClient = false;
    },

    getListOptions() {
      const clientId = this.$kst.Out.getInteger(this.searchData.ClientID);
      const clientName = clientId === null
        ? this.$kst.Out.getString(this.searchData.ClientName) : null;

      return {
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        client: clientId,
        clientname: clientName,
        status: this.$kst.Search.getValue(this.searchData.StatusID),
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.ListFields,
        withitems: this.$kst.Out.getBoolean(this.userData.WithItems),
        withitemsbyclient: this.$kst.Out.getBoolean(this.userData.WithItemsByClient)
      };
    }
  }
}
</script>